import {makeAutoObservable, runInAction} from "mobx";
import http from "../framework/http.js";
import Decimal from "decimal.js";

class UserInfoStore {
    activationStatus = null;
    displayName = null;
    cartAmount = null;
    credit = null;
    overdraftLimit = null;

    constructor() {
        makeAutoObservable(this);
        if (window.localStorage.getItem("token")) {
            this.initUserInfo();
        }
    }

    setUserInfo(user) {
        this.activationStatus =user.activationStatus;
        this.displayName = user.displayName;
        this.cartAmount = user.cartAmount;
        this.credit = user.credit;
        this.overdraftLimit = user.overdraftLimit;
    }

    async initUserInfo() {
        const res = await http.get("/getUserInfo");
        if (res.data && res.data.code === 200) {
            this.setUserInfo(res.data.data);
        }
    }

    get availableCredit() {
        if (this.credit === null) {
            return null;
        }
        return new Decimal(this.credit).sub(new Decimal(this.overdraftLimit));
    }

    setCreditAndOverdraftLimit(creditAndOverdraftLimit) {
        this.credit = creditAndOverdraftLimit ? creditAndOverdraftLimit.credit : null;
        this.overdraftLimit = creditAndOverdraftLimit ? creditAndOverdraftLimit.overdraftLimit : null;
    }

    async loadCreditAndOverdraftLimit() {
        const res = await http.get("/getCreditAndOverdraftLimit");
        if (res.data && res.data.code === 200) {
            this.setCreditAndOverdraftLimit(res.data.data);
        }
    }

}

const userInfoStore = new UserInfoStore();
export default userInfoStore;
